import { RefreshCw, ShieldCheck } from "lucide-react";
import PropTypes from "prop-types";
import { ComponentSpinner } from "@components/spinner";
import KycDocumentsCard from "./kyc-documents-card";
import KycVerificationCard from "./kyc-verification-card";
import PublisherInfoCard from "./publisher-info-card";

// Props are the page hook's `kycTab`.
const KycTab = ({ publisher, brands, summary, loading, onRetry, canSendReminder, onRemind, onForceVerify, verifying }) => {
    if (loading) {
        return (
            <div className="flex justify-center py-16">
                <ComponentSpinner />
            </div>
        );
    }

    if (!publisher) {
        return (
            <div className="rounded-xl border border-dashed border-gray-300 bg-white px-6 py-12 text-center">
                <ShieldCheck className="mx-auto h-6 w-6 text-muted" />
                <p className="mt-2 text-sm font-medium text-gray-900">Couldn&apos;t load KYC for this publisher</p>
                <p className="mt-1 text-sm text-muted">Something went wrong fetching their KYC record.</p>
                <button
                    type="button"
                    onClick={onRetry}
                    className="mt-4 inline-flex items-center gap-1.5 rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
                    <RefreshCw className="h-4 w-4" />
                    Try again
                </button>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3 lg:items-start">
            <div className="space-y-5 lg:col-span-2">
                <KycVerificationCard
                    summary={summary}
                    canSendReminder={canSendReminder}
                    onRemind={onRemind}
                    onForceVerify={onForceVerify}
                    verifying={verifying} />
                <KycDocumentsCard docs={summary.docs} submittedCount={summary.submittedCount} requiredCount={summary.requiredCount} />
            </div>

            <PublisherInfoCard publisher={publisher} brands={brands} />
        </div>
    );
};

KycTab.propTypes = {
    publisher      : PropTypes.object,
    brands         : PropTypes.arrayOf(PropTypes.string).isRequired,
    summary        : PropTypes.object,
    loading        : PropTypes.bool,
    onRetry        : PropTypes.func.isRequired,
    canSendReminder: PropTypes.bool,
    onRemind       : PropTypes.func.isRequired,
    onForceVerify  : PropTypes.func.isRequired,
    verifying      : PropTypes.bool
};

export default KycTab;
